import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { PayloadAction } from 'sos-common/js/commonTypes/action.types';

export const ADD_FILE = 'ADD_FILE';
export interface IAddFileAction extends PayloadAction<typeof ADD_FILE, FileExtendedDetails> {
  fieldName: string;
}

export const REMOVE_FILE = 'REMOVE_FILE';
export interface IRemoveAction extends PayloadAction<typeof REMOVE_FILE, FileExtendedDetails> {
  fieldName: string;
}

export type fileActions = IAddFileAction | IRemoveAction;
